export const Utils = {
  formatDate: (date: Date) => {
    // Get the day, month, year, hours, and minutes
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");

    // Determine AM or PM suffix
    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // The hour '0' should be '12'

    // Format the time as "hh:mm am/pm"
    const time = `${hours}.${minutes} ${ampm}`;

    // Combine the date and time
    return `${day}/${month}/${year} ${time}`;
  },

  deepClone: (data: any) => {
    return JSON.parse(JSON.stringify(data));
  },

  stringFormat: (data: any) => {
    return JSON.stringify(data, null, 2);
  },
  jsonParse: (data: any) => {
    return JSON.stringify(data, null, 2);
  },
  getRandomNumber: (min: number, max: number): number => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  },
};
